import { useGenericQuery } from "../../hooks/useQueries";
import SuperDropdown from "../dropdown/SuperDropdown";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import Spinner from "../spinner/Spinner";
import DefaultLoadingError from "../error/DefaultLoadingError";

export default function AutoCompleteForening(props: {
  clearAfterSelection: boolean;
  onSelectedItemChange: (item: IForening) => void;
  placeholder?: string;
}) {
  const { data, isPending } = useGenericQuery<IForening>("foreninger");

  if (isPending) {
    return (
      <Spinner
        inline
        size={14}
        className="form-control justify-content-start"
        label="Henter data"
      />
    );
  }

  // because things should be sorted
  data?.sort((a, b) => a.navn.localeCompare(b.navn));

  return (
    <>
      {!data && (
        <DefaultLoadingError
          label="Fejl: Kunne ikke hente data"
          refreshLabel="Indlæs igen"
        />
      )}
      <SuperDropdown
        items={data}
        itemsIdKey={"id"}
        itemToString={(item) => item?.navn ?? ""}
        clearInputAfterSelection={props.clearAfterSelection}
        disabled={!data}
        placeholder={props.placeholder}
        onSelectedItemEvent={(event) => {
          if (event.selectedItem) {
            props.onSelectedItemChange(event.selectedItem);
          }
        }}
        itemToElement={(item) => <DefaultDropdownItem label={item.navn} />}
      />
    </>
  );
}
